import { QuestionCircleOutlined } from '@ant-design/icons'

import { getMenuItem, MenuItem } from '@/components/ui/common/MenuItem'
import { IntlFunction } from '@/utils/messages'

export function HelpSubMenu(t: IntlFunction): MenuItem {
  return getMenuItem('', 'help', <QuestionCircleOutlined />, [
    getMenuItem(
      <a href="https://help.clayton.io/" rel="noreferrer" target="_blank">
        <span className="menu-item-title">{t('SubMenu.helpCenter')}</span>
      </a>,
      'help-center'
    ),
    getMenuItem(
      <a
        href="https://help.clayton.io/en/collections/1454139-product-release-notes"
        rel="noreferrer"
        target="_blank"
      >
        <span className="menu-item-title">{t('SubMenu.releaseNotes')}</span>
      </a>,
      'help-releastNotes'
    ),
    getMenuItem(
      <a href="https://gearset.com/legal/" rel="noreferrer" target="_blank">
        <span className="menu-item-title">{t('SubMenu.legal')}</span>
      </a>,
      'help-legal'
    ),
  ])
}
